import type { ResourceView } from "../hooks/useResources";

// Picks the walkthrough an integration detail page renders as its "// GUIDE".
//
// An admin pins a resource to an integration by slug; several can name the same
// one, so the lowest sort_order wins — the same ordering the resource library
// lists by, which makes the admin's existing lever ("lower = earlier") also
// decide which guide is the canonical one. Ties fall back to list order, which
// the API already returns sorted by sort_order then created_at DESC.
//
// Deliberately independent of connection state: a guide stays useful after
// connecting (reconnects, or a half-remembered setup step), so the caller
// renders it outside the connect block.
export const pickIntegrationGuide = (
  resources: ReadonlyArray<ResourceView>,
  integrationSlug: string,
): ResourceView | undefined => {
  if (integrationSlug === "") return undefined;
  return resources
    .filter((r) => r.integrationSlug === integrationSlug)
    .reduce<ResourceView | undefined>(
      (best, r) => (best === undefined || r.sortOrder < best.sortOrder ? r : best),
      undefined,
    );
};
